import { useEffect, useId, useRef } from 'react';

export interface ScrollerPageMarkerProps {
  intersectionObserver?: IntersectionObserver;
  page: number;
  onMarkerObserved: (markerId: string) => void;
}

const ScrollerPageMarker = ({ intersectionObserver, page, onMarkerObserved }: ScrollerPageMarkerProps) => {
  const observedMarker = useRef<Element | undefined>(undefined);
  const markerId = useId();

  // biome-ignore lint/correctness/useExhaustiveDependencies: Cleanup only on unmount; observer is stable, onMarkerElementCreated handles observation
  useEffect(() => {
    // Capture current values for cleanup
    const currentMarker = observedMarker.current;
    const currentObserver = intersectionObserver;

    return () => {
      if (currentMarker) {
        currentObserver?.unobserve(currentMarker);
      }
    };
  }, []);

  const onMarkerElementCreated = (element: Element) => {
    if (observedMarker.current) {
      intersectionObserver?.unobserve(observedMarker.current);
    }

    intersectionObserver?.observe(element);
    observedMarker.current = element;
    onMarkerObserved(markerId);
  };

  return (
    <div
      data-page={page}
      data-name="marker"
      ref={(element) => {
        if (element) onMarkerElementCreated(element);
      }}
    />
  );
};

export default ScrollerPageMarker;
